import React from 'react';
import Collapsible from 'react-collapsible';
import moment from 'moment';
import Event from '../Components/calendar/Event';
import { withNamespaces } from 'react-i18next';


function Calendar({ events, t, language, loading }) {
	const sortedEvents = [...events].sort((a, b) => moment(a.fields.begin).diff(b.fields.begin));
	const januaryEvents = [];
	const februaryEvents = [];
	const marchEvents = [];
	const aprilEvents = [];
	const mayEvents = [];
	const juneEvents = []; 
	const julyEvents = [];
	const augustEvents = [];
	const septemberEvents = [];
	const octoberEvents = [];
	const novemberEvents = [];
	const decemberEvents = [];

	const sortEvents = () => {
		sortedEvents.forEach((event) => {
			if (new Date(event.fields.begin).getMonth() === 0) {
				januaryEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 1) {
				februaryEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 2) {
				marchEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 3) {
				aprilEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 4) {
				mayEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 5) {
				juneEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 6) {
				julyEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 7) {
				augustEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 8) {
				septemberEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 9) {
				octoberEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 10) {
				novemberEvents.push(event);
			} else if (new Date(event.fields.begin).getMonth() === 11) {
				decemberEvents.push(event);
			}
		});
	};

	sortEvents();

	const yearForMonth = (monthEvents) => {
		const first = monthEvents && monthEvents.length ? monthEvents[0] : null;
		const d = first?.fields?.begin ? new Date(first.fields.begin) : new Date();
		return d.getFullYear();
	};

	const monthLabel = (monthName, monthEvents) => `${monthName} ${yearForMonth(monthEvents)}`;

	return (
		<div>
			<div id="calendar" />
			<div className="calendar-section">
				<div className="item-calendar">
					<h2 className="normal-headline">        {t('calendar')}</h2>
					<div className="calendar-grid">
						{/* 
						<EventList events={events}/>
						*/}
						

							

						{januaryEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('Januar', januaryEvents)}>
								{januaryEvents.map((event) => {
									return <Event event={event} language={language}  />;
								})}
							</Collapsible>
						) : null}
						{februaryEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('Februar', februaryEvents)}>
								{februaryEvents.map((event) => {
									return <Event event={event} language={language}  />;
								})}
							</Collapsible>
						) : null}
						{marchEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('März', marchEvents)}>
								{marchEvents.map((event) => {
									return <Event event={event} language={language}  />;
								})}
							</Collapsible>
						) : null}
						{aprilEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('April', aprilEvents)}>
								{aprilEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
						{mayEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('Mai', mayEvents)}>
								{mayEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
						{juneEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('Juni', juneEvents)}>
								{juneEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
						{julyEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('Juli', julyEvents)}>
								{julyEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
						{augustEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('August', augustEvents)}>
								{augustEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
						{septemberEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('September', septemberEvents)}>
								{septemberEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
						{octoberEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('Oktober', octoberEvents)}>
								{octoberEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
						{novemberEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('November', novemberEvents)}>
								{novemberEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
						{decemberEvents.length > 0 ? (
							<Collapsible className="month" class trigger={monthLabel('Dezember', decemberEvents)}>
								{decemberEvents.map((event) => {
									return <Event event={event} language={language} />;
								})}
							</Collapsible>
						) : null}
		{loading ? (
				<div className="no-event-grid">
				<div className="no-events">{t('loading')}...</div>
			</div>
			) : events.length === 0 ? (
				<div className="no-event-grid">
				<div className="no-events">{t('no upcoming events')}</div>
			</div>
			) : null}

					</div>
				</div>
			</div>
		</div>
	);
}

export default withNamespaces()(Calendar);
